import * as React from "react";
import type { SVGProps } from "react";
const SvgDismiss = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M2.29 21.71c.2.19.45.29.71.29s.51-.09.71-.29l8.285-8.295 8.295 8.295c.2.19.45.29.71.29v-.01a.996.996 0 0 0 .71-1.7l-8.295-8.295L21.7 3.7a.996.996 0 1 0-1.41-1.41l-8.288 8.292L3.71 2.29c-.39-.39-1.03-.39-1.42 0s-.39 1.03 0 1.42l8.293 8.293L2.29 20.3a.996.996 0 0 0 0 1.41"
    />
  </svg>
);
export default SvgDismiss;
